<template>
  <v-layout
    id="full_div_map"
    :row="!showDevices"
    wrap
  >
    <v-dialog
      v-model="showLogoutDialog"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Sortir?
        </v-card-title>
        <v-card-text>Voulez-vous vraiment fermer la session?</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            flat
            @click="showLogoutDialog = false"
          >
            Annuler
          </v-btn>
          <v-btn
            color="red darken-1"
            flat
            @click="logout()"
          >
            Déconnecter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-flex
      d-flex
      xs12
      :sm5="showDevices"
      :md7="showDevices"
      :lg8="showDevices"
      :xl9="showDevices"
      :style="{ height: mapHeight }"
    >
      <v-speed-dial
        id="main-dial"
        v-model="dial.fab"
        :top="dial.top"
        :bottom="dial.bottom"
        :right="dial.right"
        :direction="dial.direction"
        :open-on-hover="dial.hover"
        :transition="dial.transition"
        :style="{ marginRight: dialMarginRight }"
      >
        <template v-slot:activator>
          <v-btn
            v-model="dial.fab"
            color="blue darken-2"
            dark
            fab
            small
          >
            <v-icon>menu</v-icon>
            <v-icon>close</v-icon>
          </v-btn>
        </template>

        <v-btn
          fab
          dark
          small
          color="green"
          @click="showDevices = !showDevices"
        >
          <v-icon>device_hub</v-icon>
        </v-btn>

        <v-btn
          fab
          dark
          small
          color="red"
          @click="showLogoutDialog = true"
        >
          <v-icon>mdi-exit-to-app</v-icon>
        </v-btn>
      </v-speed-dial>

      <elac-map />
    </v-flex>

    <v-flex
      v-if="showDevices"
      d-flex
      xs12
      :sm7="showDevices"
      :md5="showDevices"
      :lg4="showDevices"
      :xl3="showDevices"
      elevation-10
      :style="{ height: listHeight }"
    >
      <div style="overflow-x: auto;">
        <v-toolbar
          color="primary"
          dark
        >
          <v-toolbar-title>Traceurs</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-icon @click="showDevices = false">
              close
            </v-icon>
          </v-toolbar-items>
        </v-toolbar>

        <v-card>
          <elac-devices-list />
        </v-card>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import ElacMap from '@/components/ElacMap.vue';
import ElacDevicesList from '@/components/ElacDevicesList.vue';

export default {
  components: {
    ElacMap,
    ElacDevicesList,
  },

  data: () => ({
    showDevices: true,
    showLogoutDialog: false,
    dial: {
      fab: false,
      direction: 'left',
      top: true,
      bottom: false,
      right: true,
      hover: false,
      transition: 'scale-transition',
    },
  }),

  computed: {
    dialMarginRight() {
      if (!this.showDevices) {
        return '0px';
      }

      switch (this.$vuetify.breakpoint.name) {
        case 'sm': return '58.333%';
        case 'md': return '41.666%';
        case 'lg': return '33.333%';
        case 'xl': return '25%';
        default: return '0px';
      }
    },

    mapHeight() {
      if (this.$vuetify.breakpoint.xsOnly && this.showDevices) {
        return '50vh';
      }

      return '100vh';
    },

    listHeight() {
      if (this.$vuetify.breakpoint.xsOnly && this.showDevices) {
        return '50vh';
      }

      return '100vh';
    },
  },

  watch: {
    showDevices() {
      window.dispatchEvent(new Event('resize'));
    },
  },

  mounted() {
    window.scrollTo(0, 1);
  },

  methods: {
    logout() {
      this.$store.dispatch('auth/logout')
        .then(() => {
          this.showLogoutDialog = false;
          return this.$router.push({ name: 'home' });
        });
    },
  },
};
</script>

<style>
#full_div_map {
  position: absolute;
  overflow-x: auto;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 0;
}

#main-dial {
  z-index: 999;
  position: absolute;
}

.v-overlay--active {
  z-index: 1201 !important;
}

.v-dialog__content--active {
  z-index: 1202 !important;
}
</style>
